import request from '@/utils/request'

// 获取我已购买的插件
export function getMyPlugIn () {
  return request({
    url: '/codeStoreFrontAdmin/myPlugin',
    method: 'get'
  })
}
